import { useQuery } from '@tanstack/react-query';

import { useSegment } from '@telialt/utils/src/segment';

import { apiGetPublicServiceOffers } from '../api';
import { QUERY_KEYS } from '../constants';
import { ServiceOffersRequestParams } from '../model';

export const usePublicServiceOffersQuery = (params?: ServiceOffersRequestParams) => {
    const segment = useSegment();

    return useQuery({
        queryKey: [QUERY_KEYS.PUBLIC_SERVICE_OFFERS, segment, params],
        queryFn: async () => (await apiGetPublicServiceOffers(segment, params)).data,
    });
};
